import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { decorateWith } from 'helpers/decorator';
import { detectScreenType } from 'redux/modules/device';
import { SCREEN_TYPES } from 'constants/media-queries';
export var mapStateToProps = function mapStateToProps(state) {
  return {
    isPhone: detectScreenType(state) === SCREEN_TYPES.phone
  };
};
export var PictureUnwrapped = function PictureUnwrapped(_ref) {
  var isPhone = _ref.isPhone,
      phone = _ref.phone,
      tablet = _ref.tablet,
      title = _ref.title;
  var source = isPhone ? phone : tablet;
  return React.createElement("div", {
    className: "Picture"
  }, isPhone && phone && React.createElement("img", {
    src: source,
    alt: title,
    title: title
  }), !isPhone && tablet && React.createElement("img", {
    src: source,
    alt: title,
    title: title
  }));
};
PictureUnwrapped.propTypes = {
  isPhone: PropTypes.bool,
  phone: PropTypes.string,
  tablet: PropTypes.string,
  title: PropTypes.string.isRequired
};
export var Picture = decorateWith(connect(mapStateToProps))(PictureUnwrapped);